<template>
  <div class="ownScreeningSlider" id="scroll-to">
    <div class="row" v-if="ownScreening.length > 0">
      <div
        class="col-6 px-1 my-2"
        v-for="(singleMovie, singleindex) in ownScreening"
        :key="singleindex"
      >
        <router-link to>
        <!-- :to="
            singleMovie.CategoryID == '1' || singleMovie.CategoryID == '3'
              ? {
                  name: 'regularMovies',
                  params: {
                    movieId: singleMovie.ID,
                    categoryId: singleMovie.CategoryID
                  }
                }
              : {
                  name: 'createScreen',
                  params: {
                    movieId: singleMovie.ID,
                    categoryId: singleMovie.CategoryID
                  }
                }
          " -->
          <div class="movieSlider-container mx-auto text-center">
            <div class="img-container">
              <router-link
                :to="{
                  name: 'createScreen',
                  params: {
                    movie_id: singleMovie.movie_id,
                    content_lang_id: singleMovie.content_lang_id
                  }
                }"
              >
                <img
                  v-lazy="singleMovie.md_thumbnail_url"
                  alt
                  class="img-fluid mx-auto banner"
                />
              </router-link>
            </div>
            <div class="text-center mx-auto pt-2 pt-md-3 movieSliderInfo">
              <p class="mb-0 title">{{ singleMovie.movie_title }}</p>
              <ul class="list-inline mb-0 mInfo">
                <li class="list-inline-item">{{ singleMovie.mf_name }}</li>
                <li class="list-inline-item">|</li>
                <li class="list-inline-item">{{ singleMovie.rating }}</li>
              </ul>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div v-else-if="loadingNow == false" class="row">
      <div class="col-12 text-center">
        <h5>No Movie Found</h5>
      </div>
    </div>
    <div class="row d-md-none" v-if="loadingNow">
      <div class="col-12 text-center">
        <img src="@/assets/img/loadMore.gif" class="load-more" />
      </div>
    </div>
  </div>
</template>
<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import $ from "jquery";
import EventBus from "@/eventBus.js";
import MainServices from "@/services/mainService.js";
import moment from "moment";

export default {
  name: "ownScreeningSlider",
  components: {
    Slick
  },
  data() {
    return {
      routeName: "",
      loadingNow: true,
      ownScreening: []
    };
  },
  mounted() {
    this.routeName = window.location.pathname;
    EventBus.$on("CREATESHOWING", val => {
      this.ownScreening = val;
      this.loadingNow = false;
    });
    EventBus.$on("LoadingNow", val => {
      this.loadingNow = val;
      this.ownScreening = [];
    });
  },
  watch: {
    ownScreening(newVal, oldVal) {
      this.$forceUpdate();
    }
  },
  computed: {
    ownScreening() {
      return this.ownScreening;
    }
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/partials/OwnScreeningSliderMobile.vue